import { Field as BaseField, type FieldLabelProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { labelStyle } from './CheckboxLabel.css';

type Props = FieldLabelProps;

export const CheckboxLabel = ({ ...delegated }: Props) => {
  return <BaseField.Label {...delegated} className={clsxs(labelStyle, delegated.className)} nativeLabel={false} render={<span />} />;
};
